import { Building2, Landmark, MailCheck, FileCheck2, Scale, ArrowRight, Check } from "lucide-react";
import { Button } from "./ui/button";
import { useLanguage } from "../i18n/LanguageContext";

const ICONS = [Landmark, Building2, MailCheck, FileCheck2];

const RECEPTION_IMAGE = "/assets/uba-banner-sedii.webp";

export const Services = () => {
  const { t } = useLanguage();

  return (
    <section id="servicii" className="bg-[#f8fafc] py-20 lg:py-28" data-testid="services-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <p className="section-label" data-testid="services-label">{t.services.label}</p>
          <h2
            className="font-display mt-4 text-3xl font-bold tracking-tight text-[#0d2b52] sm:text-4xl"
            data-testid="services-title"
          >
            {t.services.title}
          </h2>
          <p className="mt-4 text-base text-[#475569] sm:text-lg" data-testid="services-subtitle">
            {t.services.subtitle}
          </p>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-2">
          {t.services.items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <article
                key={i}
                className="group border border-[#e2e8f0] bg-white p-8 transition-all duration-300 hover:-translate-y-1 hover:border-[#1d6fd1]"
                data-testid={`service-card-${i}`}
              >
                <span className="flex h-12 w-12 items-center justify-center bg-[#0d2b52] transition-colors group-hover:bg-[#1d6fd1]">
                  <Icon className="h-6 w-6 text-white" />
                </span>
                <h3 className="font-display mt-6 text-xl font-bold text-[#0d2b52]">
                  {item.title}
                </h3>
                <p className="mt-3 leading-relaxed text-[#475569]">{item.desc}</p>
              </article>
            );
          })}
        </div>

        <div
          className="mt-6 flex flex-col items-start gap-6 bg-[#0d2b52] p-8 sm:flex-row sm:items-center sm:justify-between sm:p-10"
          data-testid="service-highlight"
        >
          <div className="flex items-start gap-5">
            <span className="flex h-14 w-14 shrink-0 items-center justify-center bg-[#1d6fd1]">
              <Scale className="h-7 w-7 text-white" />
            </span>
            <div>
              <h3 className="font-display text-xl font-bold text-white sm:text-2xl" data-testid="service-highlight-title">
                {t.services.highlight.title}
              </h3>
              <p className="mt-2 max-w-2xl leading-relaxed text-[#cbd5e1]" data-testid="service-highlight-desc">
                {t.services.highlight.desc}
              </p>
              <ul className="mt-4 grid gap-x-8 gap-y-2 sm:grid-cols-2" data-testid="service-highlight-list">
                {t.services.highlight.list.map((item, i) => (
                  <li key={i} className="flex items-center gap-2 text-sm font-semibold text-white" data-testid={`service-highlight-item-${i}`}>
                    <Check className="h-4 w-4 shrink-0 text-[#2f9be8]" strokeWidth={3} />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <Button
            asChild
            size="lg"
            className="shrink-0 rounded-none bg-[#1d6fd1] font-display font-bold text-white hover:bg-[#2f9be8]"
            data-testid="service-highlight-cta"
          >
            <a href="#contact">
              {t.services.highlight.cta}
              <ArrowRight className="ml-2 h-4 w-4" />
            </a>
          </Button>
        </div>

        <div className="mt-14 overflow-hidden border border-[#e2e8f0]">
          <img
            src={RECEPTION_IMAGE}
            alt={t.services.items[1].title}
            className="h-auto w-full object-contain"
            data-testid="services-image"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};
